import React from "react";
import PropTypes from "prop-types";
import { Field, withFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./reports.data.form";
import { InputDate, InputSelect } from "@de-prado-dev/react-component-library";
import { REPORTS_TYPE } from "../../../constants/index";

const ReportForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, viveros } = props;

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <form
          className="form-horizontal"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 col-md-4 mt-2 mt-md-0">
              <Field
                id="type"
                name="type"
                labelField={t("forms.reports.labels.type")}
                // className="form-control"
                component={InputSelect}
                placeholder=""
                optionLabel="label"
                optionValue="code"
                options={REPORTS_TYPE.map((item) => ({
                  ...item,
                  label: t(item.label),
                }))}
                addOptionEmpty
                classNamePrefix="dark"
              />
            </div>
            <div className="col-12 col-md-2 mt-2 mt-md-0">
              <Field
                id="dateInit"
                labelField={t("forms.reports.labels.dateInit")}
                className="form-control"
                name="dateInit"
                component={InputDate}
                language="es"
                dateFormat="dd/MM/yyyy"
              />
            </div>
            <div className="col-12 col-md-2 mt-2 mt-md-0">
              <Field
                id="dateEnd"
                labelField={t("forms.reports.labels.dateEnd")}
                className="form-control"
                name="dateEnd"
                component={InputDate}
                language="es"
                dateFormat="dd/MM/yyyy"
                defaultHours={23}
                defaultMinutes={59}
              />
            </div>
            <div className="col-12 col-md-2 mt-2 mt-md-0">
              <Field
                id="viveroUuid"
                name="viveroUuid"
                labelField={t("forms.users.labels.vivero")}
                // className="form-control"
                component={InputSelect}
                placeholder=""
                optionLabel="label"
                optionValue="uuid"
                options={viveros.map((item) => ({
                  ...item,
                  label: item.name,
                }))}
                addOptionEmpty
                classNamePrefix="dark"
              />
            </div>
            <div className="col-12 col-md-2 mt-2 mt-md-4">
              <button type="submit" className="btn btn-md btn-primary me-2">
                <i className="fas fa-search"></i>
              </button>
              {/* <button
                type="button"
                className="btn btn-md btn-danger"
                onClick={() => onClean(props.resetForm)}
                title={t("cleanFilter")}
              >
                <i className="fas fa-trash"></i>
              </button> */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

ReportForm.propTypes = {
  handleSubmit: PropTypes.func,
  onClean: PropTypes.func,
};

const ReportFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ReportForm",
})(ReportForm);

export default ReportFormF;
